<template>
  <span class="text-white">
    <span class="mr-2 text-white boxid-copy" @click="copyBoxId">
  {{ boxIdString ? boxIdString : '' }}
</span>
    <button
				class="btn btn-sm btn-link p-0 ms-2 me-1 text-decoration-none"
				@click="openModal"
				aria-label="Edit Box ID"
		>
      <i class="bi bi-pencil"></i>
    </button>
    <span class="text-white navbar-brand ml-3">{{ userName }}</span>

    <b-modal v-model="modalVisible" title="Kisten-ID ändern" hide-footer @shown="onModalShown">
     <div class="d-flex flex-column">
    <div class="d-flex">
      <input
					v-model="inputText"
					ref="boxIdInput"
					type="text"
					class="form-control me-2"
					@input="inputText = (inputText || '').toUpperCase()"
					@keyup.enter="commitInput"
			/>
      <button class="btn btn-success me-1" @click="commitInput">✔</button>
      <button class="btn btn-danger" @click="cancelInput">✖</button>
    </div>
    <div v-if="validationError" class="invalid-feedback d-block">
      {{ validationError }}
    </div>
  </div>
</b-modal>
  </span>
</template>

<script>
import { useBoxIdStore } from '../stores/BoxIdStore';
import { mapState, mapActions } from 'pinia';

export default {
	name: 'UserBadge',
	props: { userName: { type: String, required: true } },
	data() {
		return {
			modalVisible: false,
			inputText: '',
			validationError: '',
		};
	},
	computed: {
		...mapState(useBoxIdStore, ['boxIdString']),
	},
	methods: {
		...mapActions(useBoxIdStore, ['setBoxIdString']),
		openModal() {
			this.inputText = '';
			this.validationError = '';
			this.modalVisible = true;
		},
		cancelInput() {
			this.modalVisible = false;
			this.inputText = '';
			this.validationError = '';
		},
		commitInput() {
			const value = (this.inputText || '').trim().toUpperCase();
			if (!/^L2K\d{4}$/.test(value)) {
				this.validationError = 'falsches Format - benötigtes Format: "L2K" gefolgt von 4 Zahlen (z.B. L2K0001).';
				return;
			}
			this.setBoxIdString(value);
			this.modalVisible = false;
		},
		async copyBoxId() {
			const text = this.boxIdString || '';
			if (!text) return;
			try { await navigator.clipboard.writeText(text); } catch(e) {}
			if (this.$bvToast) {
				this.$bvToast.toast(`In Zwischenablage kopiert: ${text}`, {
					variant: 'Warning',
					autoHideDelay: 1200,
					solid: true,
				});
			}
		},
		onModalShown() {
			this.$nextTick(() => {
				const el = this.$refs.boxIdInput;
				if (el) { el.focus(); el.select(); }
			});
		}
	},
};
</script>
<style scoped>
.boxid-copy {
	cursor: pointer;
	transition: color .15s ease, background-color .15s ease;
	border-radius: .2rem;
	padding: 0 .25rem;
}
.boxid-copy:hover {
	color: #28a745 !important;                /* Bootstrap 4 “success” green */
	background-color: rgba(40,167,69,.12);    /* subtle green highlight */
}
</style>

